import baseRequest from "../_core/baseRequest";
const namingRules = {};

export default {
    getCourierList: params => baseRequest.post("/courier/list", params),
    getCourier: params => baseRequest.get(`/courier/${params.courierId}`),
    getDedicationList: params => baseRequest.post("/courier/dedicationlist", params),
    createCourier: params => baseRequest.post("/courier", params),
    updateCourier: params => baseRequest.put(`/courier/${params.courier._id}`, params),
    uploadImage: params => baseRequest.uploadFile("courier/uploadimage", params),
    updateStatus: params => baseRequest.put("/courier/status", params),
    updateCourierDocumentStatus: params => baseRequest.put("/courier/documents/approval", params),
    createCourierCallRecords: params => baseRequest.post("/courier/call-records", params),
    getCourierCallStatuses: params => baseRequest.get("/courier/call-statuses", params),
    /* 
    will be removed on backend
    createCourierEquipmentRequests: params =>
        baseRequest.post("/courier/equipment-requests", params), */
    updateCourierOnboardingStatus: params => baseRequest.put("/courier/onboarding-status", params),
    rejectOnboardingDocumentVerificationStatus: params =>
        baseRequest.put("/courier/onboarding/reject-documents-verification", params),
    approveOnboardingDocumentVerificationStatus: params =>
        baseRequest.put("/courier/onboarding/approve-documents-verification", params),
    blockCourier: params => baseRequest.put("/courier/onboarding/block-courier", params),
    unblockCourier: params => baseRequest.put("/courier/onboarding/unblock-courier", params),
    rejectCourierApplication: params =>
        baseRequest.put("/courier/onboarding/reject-courier", params),
    undoCourierRejection: params =>
        baseRequest.put("/courier/onboarding/undo-courier-rejection", params),
    getDocumentsProgress: params =>
        baseRequest.get(`/courier/onboarding/documents-progress/${params.courierId}`),
    getCourierDocumentsRejectHistory: params =>
        baseRequest.get(
            `/courier/onboarding/documents-reject-history/${params.courierId}?${
                params.documentType ? `documentType=${params.documentType}` : ""
            }`
        ),

    changePassword: params => baseRequest.put("/courier/password", params),
    getCourierMapList: params => baseRequest.post("/courier/maplist", params),
    getCourierStatusLogs: params => baseRequest.post(`/courier/log/${params.courierId}`, params),
    getHoursReport: params => baseRequest.post("/courier/report/hour", params),
    getShiftsReport: params => baseRequest.post("/courier/report/shift", params),
    getDailyShiftsReport: params => baseRequest.post("/courier/report/dailyreport", params),
    getFeedbacksReport: params => baseRequest.post("/courier/report/feedback", params),
    getSubCompaniesReport: params => baseRequest.post("/courier/report/subcompanies", params),
    getDedicationsReport: params => baseRequest.post("/courier/report/dedication", params),
    uploadCourierFile: params => baseRequest.uploadFile("courier/uploadfile", params),
    insertCourierFiles: params => baseRequest.post("/courier/insertcourierfiles", params),
    removeCourierFile: params => baseRequest.post("/courier/removecourierfile", params),
    getPoolCouriers: params =>
        baseRequest.get(`/courier/pool` + baseRequest.queryString(params, namingRules)),
    getRegions: params => baseRequest.get(`/regions?city=${params.city}`),
    getRegionGroups: params =>
        baseRequest.get(
            `/regiongroups?${params?.companyId ? "companyId=" + params.companyId : ""}${
                params?.city ? "&city=" + params.city : ""
            }`
        ),
    getCouriersOfCompany: params =>
        baseRequest.get(`/courier/dedicate` + baseRequest.queryString(params, namingRules)),
    courierDedicationLog: params => baseRequest.get(`/courier/dedication-log/${params.courierId}`),
    dedicateCompanyCouriers: params => baseRequest.post("/courier/dedicate", params),
    getMultipleSelectCities: params =>
        baseRequest.get(
            `/company/sub?offset=${params.offset}${params.companyId &&
                "&companyId=" + params.companyId}&limit=${params.limit}&city=${params.city}&`
        ),
    getMultipleSelectCompanies: params =>
        baseRequest.get(
            `/company/sub?offset=${params.offset}${params.companyId &&
                "&companyId=" + params.companyId}&limit=${params.limit}&city=${params.city}&`
        ),
    getMultipleSelectRegions: params => baseRequest.get(`/regions?city=${params.city}`),
    getMultipleSelectRegionGroups: params =>
        baseRequest.get(
            `/regiongroups${params?.companyId ? "?companyId=" + params.companyId : ""}`
        ),

    getMultipleSelectSubCompanies: params =>
        baseRequest.get(
            `/company/sub?offset=${params.offset}${params.companyId &&
                "&companyId=" + params.companyId}&limit=${params.limit}&city=${
                params.city
            }&regions=${params.regions.join(".")}`
        ),
    getSubCompaniesByRegionGroup: params =>
        baseRequest.get(
            `/regiongroups/subcompanies?${params.companyId &&
                "companyId=" + params.companyId}&city=${
                params.city
            }&regionGroups=${params?.regionGroups?.join(".")}&disabled=${params?.disabled}`
        ),
    courierUpdateDedication: params => baseRequest.post("/courier/updatededication", params),
    updateAllCouriersDisable: params => baseRequest.post("/courier/disable", params),
    getDeliveryLocations: params => baseRequest.post("/courier/getlocationsofdelivery", params),
    getCurrentDelivery: params => baseRequest.get(`/courier/currentDelivery/${params.courierId}`),
    getSlotCouriers: params =>
        baseRequest.get(`/courier/slot-couriers?companyId=${params.companyId}`),
    getCourierByTckn: params =>
        baseRequest.get(`/courier/courier-by-tckn/${params.courierTckn}`, params),
    getAvailableCouriersForPreferredCourier: (params, allCityCouriers) =>
        baseRequest.get(
            `/courier/available-courier-by-subcompany/${params.subCompanyId}?courierType=${
                params.courierType
            }${params?.strict ? `&strict=${params.strict}` : ""}${
                allCityCouriers ? `&allCityCouriers=${allCityCouriers}` : ""
            }${params.allPoolCouriers ? `&allPoolCouriers=${params.allPoolCouriers}` : ""}`
        ),
    listAvailableCouriers: params =>
        baseRequest.get(
            `/courier/couriers-by-subcompany/${params.subCompanyId}?${
                params?.courierType ? `courierType=${params.courierType}` : ""
            }${params?.distance ? `&distance=${params.distance}` : ""
            }${params.availableCouriersPage ? `&availableCouriersPage=${params.availableCouriersPage}` : ""}`
        ),
    getCourierHomeLocation: params => baseRequest.post("/courier/location", params),
    getCourierShifts: params =>
        baseRequest.get(
            `/courier/shifts/${params.courierId}?${
                params.startDate ? `startDate=${params.startDate}` : ""
            }${params.endDate ? `&endDate=${params.endDate}` : ""}`,
            params
        ),
    getDedicatedCourier: params =>
        baseRequest.get(
            `/courier/dedicated-couriers/${params.companyId}/${params.subCompanyId}`,
            params
        ),
    updateShiftSuggestionOptions: params =>
        baseRequest.post("/courier/shift-suggestion-options", params),
    updateCourierTransferCenter: params =>
        baseRequest.put(`/courier/dedicated-transfer-centers/${params.courierId}`, params),
    getCourierTerminals: params => baseRequest.post("/courier/list-terminals", params),
    updateCourierTerminal: params => baseRequest.post("/courier/update-terminal", params),
    getCourierInfo: params => baseRequest.get(`/courier/courier-info/${params.courierId}`),
    getShiftEditLogsReport: params => baseRequest.post("/shifts/reports/shift-edit-logs", params),
    getCustomerMapList: params => baseRequest.post("/courier/customer-maplist", params),
    listMotorTypes: params => baseRequest.get("/courier/motor-types", params),
    listDrivingLicenseTypes: params => baseRequest.get("/courier/driving-license-types", params)
};
